import { useState } from "react";

export const useAuth = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  const logout = () => {
    // Realizar la lógica de cierre de sesión
    localStorage.clear();
    setIsAuthenticated(false);
  };

  const loginHook = () => {
    // Realizar la lógica de inicio de sesión
    setIsAuthenticated(true);
  };

  return { isAuthenticated, loginHook, logout };
};
